import React from 'react';
import { TabLink as NextNavLink } from '@framework/router/Next/Link';
import cn from 'classnames';
import BookDemoButton from '@/dataroom/ui/common/BookDemoButton';
import GetStartedButton from '@/dataroom/ui/components/Landing/common/GetStartedButton';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import baseStyles from '@/dataroom/ui/components/Landing/dealvdr/tenantDealvdrStyles.module.scss';
import spacesStyles from '@dealroadshow/uikit-styles/helpers/spaces.module.scss';
import styles from './startActions.module.scss';

interface IProps {
  dividerClassName?: string,
  isGetStartedButton?: boolean,
}

const StartActions = ({ dividerClassName, isGetStartedButton }: IProps) => (
  <div className={ styles.actionsWrp }>
    <BookDemoButton className={ cn(baseStyles.actionButton, styles.bookDemoButton) } />
    <span className={ cn(styles.buttonsDivider, dividerClassName) }>or</span>
    { isGetStartedButton ? (
      <GetStartedButton className={ cn(baseStyles.actionButton, styles.getStartedButton, spacesStyles.mrn) } />)
      : (
        <NextNavLink to="/get-a-quote">
          <Button
            variant={ ButtonVariantType.action }
            className={ cn(baseStyles.actionButton, styles.getStartedButton, spacesStyles.mrn) }
            title="Get a Quote"
            dataTest="learnMoreGetQuoteButton"
          />
        </NextNavLink>
      ) }
  </div>
);

export default StartActions;
